<template>
  <div>
    <h2 class="vcr-page__header">{{ i18n.t('/Vcr/Proposal/Title') }}</h2>
    <hr />

    <table>
      <tbody>
        <tr>
          <td colspan="2" class="vcr-page__table-first-column">
            {{ i18n.t('/Vcr/Proposal/Total Label') }}
          </td>
          <td data-qa="vcr-purchase-price">
            {{ i18n.n(quote.Metadata.Prices.TotalPrice.PurchaseExcl, 'currency') }}
          </td>
          <td data-qa="vcr-selling-price">
            {{ i18n.n(quote.Metadata.Prices.TotalPrice.Excl, 'currency') }}
          </td>
          <td data-qa="vcr-margin-price">
            {{ CurrencyHelper.margin(quote.Metadata.Prices.TotalPrice.MarginExcl) }}
          </td>
          <td data-qa="vcr-margin-percentage">
            {{ CurrencyHelper.marginPercentage(quote.Metadata.Prices.TotalPrice.MarginPercentage) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CurrencyHelper from '@/helpers/currencyHelper'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      CurrencyHelper: CurrencyHelper,
    }
  },
  computed: {
    ...mapGetters({
      quote: 'quote/get',
    }),
  },
}
</script>
